import { Button, Col, Modal, Row } from "antd";
import { Form, Formik } from "formik";
import * as Yup from 'yup';
import SelectInput from "../inputs/SelectInput";
import TextInput from "../inputs/TextInput";
import DateInput from "../inputs/DateInput";
import { getData, postData } from "../../helpers/api";
import { useEffect, useState } from "react";
import { confirmationRoles, rolesConst } from "../../constants/others";
import { openNotification } from "../../helpers/alerts";

const AddSpend = (props) => {
    const { isOpen, closeModal } = props;
    const [users, setUsers] = useState([]);
    const [products, setProducts] = useState([]);
    const createSpend = async (values) => {
        try {
            await postData("/spend", {
                user: values.prefix,
                paymentAmount: values.paymentAmount,
                product: values.productName,
                prefix: values.prefix,
                paymentDate: values.paymentDate,
            });
            openNotification(`Spend a été ajouter avec succès`, 'success')
            closeModal()
        } catch (error) {
            openNotification(`Erreur d'ajouter le spend, veuillez vérifier vos données`, 'error')
            console.error("Error creating spend:", error);
        }
    }

    const getUsers = async () => {
        try {
            const res = await getData('/users/confirmations')
            setUsers(res.data.map((user) => ({ value: user.id, label: user.name })))
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    }

    const getProducts = async () => {
        try {
            const res = await getData("/products");
            setProducts(res.data.map((product) => ({ value: product.id, label: product.name })))
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getUsers()
        getProducts()
    }, [])
    return (
        <Modal
            open={isOpen}
            title="Ajouter un paiement"
            onCancel={closeModal}
            footer={null}
        >
            <Formik
                initialValues={{
                    role: null,
                    paymentAmount: "",
                    productName: null,
                    prefix: null,
                    paymentDate: "",
                }}
                validationSchema={Yup.object({
                    role: Yup.string().required("Le role est requis"),
                    paymentAmount: Yup.string().required("Le montant du paiement est requis"),
                    productName: Yup.string().required("Le nom du produit est requis"),
                    prefix: Yup.string().when("role", {
                        is: (val) => val !== rolesConst.ConfirmationConvertion,
                        then: () => Yup.string().required("L'employeur est requis"),
                        otherwise: () => Yup.string().notRequired(),
                    }),
                    paymentDate: Yup.string().required("La date de paiement est requise"),
                })}
                onSubmit={(values, submitProps) => {
                    createSpend(values);
                }}
            >
                {({ values, handleSubmit }) => (
                    <Form>
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <SelectInput
                                    name="role"
                                    size="large"
                                    placeholder="Role"
                                    options={confirmationRoles.map(role => ({
                                        value: role,
                                        label: role
                                    }))}
                                />
                            </Col>
                            <Col span={24}>
                                <SelectInput
                                    name="prefix"
                                    size="large"
                                    placeholder="l'employeur"
                                    options={users}
                                />
                            </Col>
                            <Col span={24}>
                                <SelectInput
                                    name="productName"
                                    size="large"
                                    placeholder="Produit"
                                    options={products}
                                />
                            </Col>
                            <Col span={24}>
                                <TextInput
                                    name="paymentAmount"
                                    placeholder="montant du paiement"
                                    size="large"
                                />
                            </Col>
                            <Col span={24}>
                                <DateInput
                                    name="paymentDate"
                                    placeholder="Date de paiement"
                                    size="large"
                                />
                            </Col>
                            <Col span={24} style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                                <Button type="primary" htmlType="submit">Ajouter</Button>
                                <Button onClick={closeModal}>Annuler</Button>
                            </Col>
                        </Row>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
}

export default AddSpend;